import type { JSX } from "react";
import type { LiteralUnion } from "type-fest";

import { ActionIcon, CopyButton as BaseCopyButton, Tooltip } from "@mantine/core";

import { CheckMark, CopyIcon } from "../../assets";

interface CopyButtonProps {
    value: string;
    showTooltip?: {
        copyLabel: LiteralUnion<"Copy", string>;
        copiedLabel: LiteralUnion<"Copied", string>;
    };
    copyIconOverride?: React.SVGProps<SVGSVGElement>;
    checkMarkOverride?: React.SVGProps<SVGSVGElement>;
}

export function CopyButton({
    value,
    showTooltip,
    copyIconOverride,
    checkMarkOverride,
}: CopyButtonProps): JSX.Element | null {
    return (
        <BaseCopyButton value={value}>
            {({ copied, copy }) => {
                return (
                    <Tooltip
                        hidden={!showTooltip}
                        label={copied ? showTooltip?.copiedLabel : showTooltip?.copyLabel}
                        withArrow
                        position="right"
                    >
                        <ActionIcon color="text" onClick={copy} variant="subtle" id="copy-action-icon" size={"sm"}>
                            {copied ? (
                                <CheckMark height="1rem" {...checkMarkOverride} />
                            ) : (
                                <CopyIcon height="1rem" {...copyIconOverride} />
                            )}
                        </ActionIcon>
                    </Tooltip>
                );
            }}
        </BaseCopyButton>
    );
}
